import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MasterCardLeafCollectionTagReport } from './Pages';

export const MasterCardLeafCollectionTagReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={MasterCardLeafCollectionTagReport} />
    </Fragment>
)